<template>
    <div class="mt-2" style="height: 300px; position: relative">
        <button class="d-none d-md-block show-hide-button" v-tooltip="showChart ? $t('AppAnomaliasMachineDailyPerDay.Exibir tabela') : $t('AppAnomaliasMachineDailyPerDay.Exibir gráfico')"
                @click="showHideChart">
            <span :class="showHideChartClass" style="fontSize: 1.3rem"/>
        </button>

        <app-line-chart v-if="showChart"
                        :chart_data="machineryDailyChartData"  :series_symbol="$t('AppAnomaliasMachineDailyPerDay.diárias')"
                        :chart_title="$t('AppAnomaliasMachineDailyPerDay.Diárias de Maquinário por Dia')" style="position: absolute;width: 100%"/>

        <DataTable  v-else :value="dataTableData" style="text-align: center" dataKey="field_id">
            <template #header>
                <div class="table-header center" style="font-size: 18px;font-weight: 400;">
                    {{$t('AppAnomaliasMachineDailyPerDay.Horas de Maquinário por Dia')}}
                </div>
                <app-button type="primary" style="position: absolute;right: 5px;top: 5px;" @handleClick="exportCsv">
                    <span class="pi pi-external-link center pr-1"></span>
                     {{$t('AppAnomaliasMachineDailyPerDay.Exportar')}}
                </app-button>
            </template>

            <Column field="date" :header="$t('AppAnomaliasMachineDailyPerDay.Dia')">
                <template #body="slotProps">
                    {{dateFormatWithoutYear(slotProps.data.date/1000)}}
                </template>
            </Column>
            <Column headerClass="headerClass" bodyClass="bodyClass"
                    field="pa_carregadeiras" :sortable="true" :header="$t('AppAnomaliasMachineDailyPerDay.Pás-Carregadeiras')">
                <template #body="slotProps">
                    {{slotProps.data.PA_CARREGADEIRA}}
                </template>
            </Column>
            <Column headerClass="headerClass" bodyClass="bodyClass"
                    field="basculantes" :sortable="true" :header="$t('AppAnomaliasMachineDailyPerDay.Caminhões Basculantes')">
                <template #body="slotProps">
                    {{slotProps.data.BASCULANTE}}
                </template>
            </Column>
            <Column headerClass="headerClass" bodyClass="bodyClass"
                    field="pipa" :sortable="true" :header="$t('AppAnomaliasMachineDailyPerDay.Caminhões Pipa')">
                <template #body="slotProps">
                    {{slotProps.data.PIPA}}
                </template>
            </Column>
            <Column headerClass="headerClass" bodyClass="bodyClass"
                    field="escavadeiras" :sortable="true" :header="$t('AppAnomaliasMachineDailyPerDay.Escavadeiras')">
                <template #body="slotProps">
                    {{slotProps.data.ESCAVADEIRA}}
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script>

import AppAnomaliasArrow from "./AppAnomaliasArrow";
import AppLineChart from "../analysis/AppLineChart";

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import moment from "moment";
import AppButton from "../../common/AppButton";
import dateFormatWithoutYear from "@/mixins/DateMixin";
import exportJsonToCsv from  "@/mixins/JsonToCsvMixin";
import {ANOMALIAS_MACHINERY, CSV_FIELDS_DAILY, CSV_LABELS_DAILY} from "./AppAnomaliasOptions";
import Tooltip from "primevue/tooltip";

export default {
    mixins: [dateFormatWithoutYear, exportJsonToCsv],
    data() {
        return {
            machineryDailyChartData: [],
            showChart: true,
            dataTableData: [],
            anomaliasMachinery: ANOMALIAS_MACHINERY()
        }
    },
    props: {
        orders_response: {
            type: Array,
        },
        last_searched_dates: {
            type: Object,
        },
    },
    methods: {
        exportCsv() {
            let csvData = [];

            let tempData = JSON.parse(JSON.stringify(this.dataTableData));

            tempData.forEach((data) => {
                data.date = this.dateFormat(data.date / 1000);
                if (data.PA_CARREGADEIRA) {
                    data.PA_CARREGADEIRA = parseInt(data.PA_CARREGADEIRA);
                }
                if (data.BASCULANTE) {
                    data.BASCULANTE = parseInt(data.BASCULANTE);
                }

                if (data.PIPA) {
                    data.PIPA = parseInt(data.PIPA);
                }

                if (data.ESCAVADEIRA) {
                    data.ESCAVADEIRA = parseInt(data.ESCAVADEIRA);
                }

                csvData.push(data)
            });

            this.exportJsonToCsv(CSV_FIELDS_DAILY, CSV_LABELS_DAILY, csvData, 'maquinario_diaria');
        },
        showHideChart() {
            this.showChart = !this.showChart;
        },
        getMachineDailySumByDay(orders) {
            let machineDailySumByDay = [];

            orders.forEach(order => {
                order.machinery_list.forEach(machine => {

                    let index = machineDailySumByDay.findIndex(i => (i.code === machine.type &&
                        i.date.diff(moment(order.start_date * 1000).startOf('day')) === 0) );

                    let daily = 0;

                    daily = machine.final_hour_meter;

                    if (index >= 0) {
                        machineDailySumByDay[index].daily += daily;
                    } else {
                        machineDailySumByDay.push({
                            title: this.getMachineTitleFromType(machine.type),
                            date: moment(order.start_date * 1000).startOf('day'),
                            daily: daily,
                            code: machine.type
                        })
                    }
                })
            })

            return machineDailySumByDay;
        },
        buildDefaultSeriesDataForAllDaysAndMachines(enumeratesDates) {
            let tempSeriesData = [];

            tempSeriesData.push({
                data: [],
                findNearestPointBy: 'x',
                name: this.anomaliasMachinery[1].name,
                step: false,
                code: this.anomaliasMachinery[1].code
            });

            tempSeriesData.push({
                data: [],
                findNearestPointBy: 'x',
                name: this.anomaliasMachinery[2].name,
                step: false,
                code: this.anomaliasMachinery[2].code
            });

            tempSeriesData.push({
                data: [],
                findNearestPointBy: 'x',
                name: this.anomaliasMachinery[3].name,
                step: false,
                code: this.anomaliasMachinery[3].code
            });

            tempSeriesData.push({
                data: [],
                findNearestPointBy: 'x',
                name: this.anomaliasMachinery[4].name,
                step: false,
                code: this.anomaliasMachinery[4].code
            });

            enumeratesDates.forEach(date => {
                tempSeriesData.forEach(tempData => {
                    tempData.data.push([date.valueOf(), 0]);
                });
            });

            return tempSeriesData;
        },
        populateMachinesDailyUsageChartData(orders, dates) {
            let enumeratesDates = this.enumerateDaysBetweenDate(dates.start_date, dates.end_date);
            let machineDailySumByDay = this.getMachineDailySumByDay(orders);
            let tempSeriesData = this.buildDefaultSeriesDataForAllDaysAndMachines(enumeratesDates);

            machineDailySumByDay.forEach(machineData => {
                tempSeriesData.forEach(machineryTypeTempData => {
                    machineryTypeTempData.data.forEach(dataItem => {
                        if (machineData.date.diff(dataItem[0]) === 0 && machineryTypeTempData.code === machineData.code) {
                            dataItem[1] = parseFloat(machineData.daily.toFixed(2));
                        }
                    })
                })
            })

            this.machineryDailyChartData = tempSeriesData;
            this.computeDataTableData(machineDailySumByDay, enumeratesDates);
        },
        enumerateDaysBetweenDate(startDate, endDate) {
            let dates = [];

            let currentDate = moment(startDate).startOf('day');
            let lastDate = moment(endDate).startOf('day');

            dates.push(currentDate.clone().toDate());
            while(currentDate.add(1, 'days').diff(lastDate) <= 0) {
                dates.push(currentDate.clone().toDate());
            }

            return dates;
        },
        getMachineTitleFromType(type) {
            let machinery = this.anomaliasMachinery.find(obj => obj.code === type);
            return machinery.name;
        },
        computeDataTableData(machineDailySumByDay, enumeratesDates) {
            let dataTableTemp = [];

            enumeratesDates.forEach(date => {
                dataTableTemp.push({
                    date: date.valueOf(),
                    PA_CARREGADEIRA: 0,
                    BASCULANTE: 0,
                    PIPA: 0,
                    ESCAVADEIRA: 0,
                });

                machineDailySumByDay.forEach(machineDailyByDay => {
                    if (machineDailyByDay.date.diff(moment(dataTableTemp[dataTableTemp.length - 1].date).startOf('day')) === 0) {
                        dataTableTemp[dataTableTemp.length - 1][machineDailyByDay.code] =
                            machineDailyByDay.daily;
                    }
                })
            })
            this.dataTableData = dataTableTemp;
        }
    },
    watch: {
        orders_response: {
            handler: function (val) {
                this.populateMachinesDailyUsageChartData(val, this.last_searched_dates);
            },
            deep: true
        },
    },
    components: {
        AppButton,
        AppAnomaliasArrow, AppLineChart, DataTable, Column
    },
    computed: {
        showHideChartClass: function () {
            return this.showChart ? 'pi pi-table' : 'pi pi-chart-line';
        }
    },
    directives: {
        tooltip: Tooltip
    },

}

</script>

<style scoped lang="scss">

.show-hide-button {
    z-index: 999;
    position: absolute;
    color: gray;
    opacity: 0.8;
    cursor: pointer;
    left: 0;
    border: none;
    background-color: white;
    padding: 15px 0 0 10px;
}

</style>
